import React, { useEffect, useState } from 'react';
import { Clock, XCircle } from 'lucide-react';

interface HoldTimerProps {
  expiresAt: string;
  onExpire: () => void;
}

export const HoldTimer: React.FC<HoldTimerProps> = ({ expiresAt, onExpire }) => {
  const [timeRemaining, setTimeRemaining] = useState(0);

  useEffect(() => {
    const calculateRemaining = () => {
      const remaining = Math.max(0, (new Date(expiresAt).getTime() - Date.now()) / 1000);
      return remaining;
    };

    setTimeRemaining(calculateRemaining());

    const interval = setInterval(() => {
      const remaining = calculateRemaining();
      setTimeRemaining(remaining);

      if (remaining === 0) {
        onExpire();
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [expiresAt, onExpire]);

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = Math.floor(timeRemaining % 60);
  const isWarning = timeRemaining < 60 && timeRemaining > 0;
  const isExpired = timeRemaining === 0;

  const getTimerStyles = () => {
    if (isExpired) {
      return {
        border: 'border-red-500',
        text: 'text-red-500',
        icon: 'text-red-500'
      };
    }
    if (isWarning) {
      return {
        border: 'border-yellow-500',
        text: 'text-yellow-500',
        icon: 'text-yellow-500'
      };
    }
    return {
      border: 'border-primary',
      text: 'text-primary',
      icon: 'text-primary'
    };
  };

  const styles = getTimerStyles();

  return (
    <div
      className={`
        flex items-center gap-3 w-full h-14 px-4
        bg-dark-card border ${styles.border}
        rounded-xl transition-all duration-300
      `}
    >
      {isExpired ? (
        <XCircle className={`w-5 h-5 ${styles.icon}`} />
      ) : (
        <Clock className={`w-5 h-5 ${styles.icon}`} />
      )}

      <span className={`text-sm font-montserrat ${styles.text}`}>
        {isExpired ? 'Reserva expirada' : 'Reserva bloqueada por:'}
      </span>

      <span className={`ml-auto text-2xl font-bebas ${styles.text}`}>
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </span>
    </div>
  );
};
